'use strict';

/**
 *
 * @category   View
 * @module     collection
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ColidoLayoutView = require('base/Colido.LayoutView');
var MonetaryValueComponent = require('../../../edit/views/components/field-monetary-value');

var template = require('../../templates/layout/sell-modal.hbs');

var SellModalView = ColidoLayoutView.extend({
    template: template,

    ui: {
        actionClose: '[data-action="close"]',
        actionSell: '[data-action="sell"]',
        actionWithdrawFromSale: '[data-action="withdraw"]',
        currency: 'select',
        form: 'form',
    },

    events: {
        'click @ui.actionClose': 'actionClose',
        'submit @ui.form': 'actionSell',
        // 'click @ui.actionSell': 'actionSell',
        'click @ui.actionWithdrawFromSale': 'actionWithdrawFromSale',
    },

    viewData: {
        field: function() {
            return this.model.collection.catalog.getEditField('retailPrice');
        },

        headline: function() {
            var fieldName = this.model.collection.catalog.get('fieldsGridAttributeMap').headline;

            return this.model.getMergedTextValues(fieldName);
        },

        subheadline: function() {
            var fieldName = this.model.collection.catalog.get('fieldsGridAttributeMap').subheadline;

            return this.model.getMergedTextValues(fieldName);
        },
    },

    actionClose: function(event) {
        this.trigger('close:modal', 'dashboard');
    },

    getData: function() {
        var data = {};
        var field = this.model.collection.catalog.getEditField('retailPrice');

        data[field.name] = this.$('[name="' + field.name + '"]').val().trim();
        data[field.unitField] = this.$('[name="' + field.unitField + '"]').val().trim();
        data.selldescription = this.$('[name="selldescription"]').val().trim();

        return data;
    },

    onShow: function() {
        var field = this.model.collection.catalog.getEditField('retailPrice');

        // Render select fields
        this.renderSelectOptions(
            this.ui.currency,
            App.radio().request('currencies:collection'),
            'key',
            'shortName',
            function(option) {
                return this.model && this.model.get(field.unitField) === option.value
            }.bind(this)
        );
    },

    showValidationErrors: function() {
        var errors = this.getValidationErrors();

        this.$('input').closest('fieldset').removeClass('error');

        Object.keys(errors).forEach(function(fieldName){
            this.$('[name="' + fieldName + '"]').closest('fieldset').addClass('error');
        }.bind(this));
    },

    getValidationErrors: function() {
        var formData = this.getData();
        var validationErrors = {}

        if (formData.retailPrice === '') {
            validationErrors.retailPrice = true;
        }

        return  validationErrors;
    },

    isValid: function() {
        var validationErrors = this.getValidationErrors();

        return Object.keys(validationErrors).length ? false : true;
    },

    actionSell: function(event) {
        event && event.preventDefault();

        var formData = this.getData();

        if (!this.isValid()) {
            this.showValidationErrors();

            return;
        }

        var shop = this.getOption('shop');
        var item = new shop.objects.model(null, {collection: shop.objects});

        var data = {
            id: this.model.id,
            forSale: true,
            retailPrice: formData.retailPrice,
            retailPriceCurrency: formData.retailPriceCurrency,
            sellingOptions: {selldescription: formData.selldescription},
        };

        item.save(data, {
            success: function(model, response, options) {
                shop.objects.add(model);

                this.trigger('close:modal');

                var itemLink = App.html.link({
                    url: '/shops/' + shop.id + '/show/' + this.model.id,
                    label: '»' + _.escape(model.get('properName')) + '«',
                });

                Messenger().post({
                    type: 'success',
                    message: App.t('collection::shop:sell:response:success', {itemLink: itemLink}),
                });
            }.bind(this),
            error: function(model, response, options) {
                var errorMessage = Messenger().post({
                    type: 'error',
                    message: App.t('collection::shop:sell:response:error'),
                    actions: {
                        'try-again': {
                            label: App.t('global::messenger:button:try-again'),
                            action: function() {
                                errorMessage.hide();
                                this.actionSell(event);
                            }.bind(this),
                        },
                        'cancel': {
                            label: App.t('global::messenger:button:cancel'),
                            action: function() {
                                errorMessage.hide();
                            }.bind(this),
                        },
                    },
                });
            }.bind(this),
        });
    },

    actionWithdrawFromSale: function(){
        var shop = this.getOption('shop');
        var item = new shop.objects.model(null, {collection: shop.objects});

        item.set('id', this.model.id);

        item.destroy({
            success: function(model, response, options) {
                this.trigger('close:modal');

                Messenger().post({
                    type: 'success',
                    message: App.t('collection::shop:sell:withdraw:response:success', {itemName: _.escape(model.get('properName'))}),
                });
            }.bind(this),
            error: function(model, response, options) {
                var errorMessage = Messenger().post({
                    type: 'error',
                    message: App.t('collection::shop:sell:withdraw:response:error'),
                    actions: {
                        'try-again': {
                            label: App.t('global::messenger:button:try-again'),
                            action: function() {
                                errorMessage.hide();
                                this.actionWithdrawFromSale(event);
                            }.bind(this),
                        },
                        'cancel': {
                            label: App.t('global::messenger:button:cancel'),
                            action: function() {
                                errorMessage.hide();
                            }.bind(this),
                        },
                    },
                });
            }.bind(this),
        });
    },
});

module.exports = SellModalView;